export default "__VITE_ASSET__2fooyarX__"